export default __webpack_public_path__ + "static/media/bh4.8b92c553.jpg";